<template>
  <box-model title="加工记录趋势图">
    <template v-slot:content>
      <div v-if="!show" class="no-data-sty" style="height: 244px;">暂无数据</div>
      <div v-else>
        <div class="title flex-y-center">
          <div class="tag1"></div>
          <span class="mgn-r-16">今年加工趋势</span>
          <div class="tag2"></div>
          <span>去年加工趋势</span>
          <div class="unit">单位：条</div>
        </div>
        <div id="echart1" class="con"></div>
      </div>
    </template>
  </box-model>
</template>

<script>
  import echarts from 'echarts'
  import { getRecordStatisticsTrend } from '@/api/index';
  export default {
    data() {
      return {
        show: false
      }
    },
    components: {
      "box-model": () => import("../../components/common/Model.vue")
    },
    mounted() {
      this.getRecordStatisticsTrendFn();
    },
    methods: {
      init(res) {
        const myChart = echarts.init(document.getElementById("echart1"));
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                  color: '#dddc6b'
              }
            },
            backgroundColor: '#fff',
            formatter: function(params) {
              let item = params[0];
              let arr = [];
              for(let i = 0;i<params.length;i++){
                let str = `
                  <div style="display: flex;align-items: center;margin-bottom: 8px;">
                    <div style="width: 8px;height: 8px;background: ${params[i].borderColor};border-radius: 50%;"></div>
                    <div style="color: #000E2B;font-size: 15px;margin-left: 4px;line-height: 16px;">${params[i].seriesName}：${params[i].value}条</div>    
                  </div>
                `;
                arr.push(str);
              }
              let result = `
                <div style="padding: 12px;">
                  <div style="color: #3E3E3E;font-size: 15px;">${item.axisValue}</div>
                  <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                  ${arr.join('')}
                </div>
              `;
              return result;
            }
          },
          grid: {
            left: '0%',
            top:'15px',
            right: '0%',
            bottom: '10%',
            containLabel: true
          },
          dataZoom: [
            {
              type: "slider",
              realtime: true,
              startValue: 0,
              endValue: 5,
              height: 4,
              handleSize: 0,            // 两边手柄尺寸
              showDetail: false,        // 拖拽时是否展示滚动条两侧的文字
              top: "95%",
              borderColor: "transparent",
              borderRadius: {topLeft: '10%', topRight: '10%', bottomLeft: '10%', bottomRight: '10%'}
            },
            {
              type: "inside",           // 支持内部鼠标滚动平移
              startValue: 0,
              endValue: 5,
              zoomOnMouseWheel: false,  // 关闭滚轮缩放
              moveOnMouseWheel: true,   // 开启滚轮平移
              moveOnMouseMove: true,    // 鼠标移动能触发数据窗口平移
            },
          ],
          legend: {
            show: false
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              axisLabel:  {
                textStyle: {
                  color: "rgba(255,255,255,.6)",
                  fontSize:14,
                },
              },
              axisLine: {
                lineStyle: { 
                  color: 'rgba(255,255,255,.1)'
              }
            },
            data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
            },
            {
              axisPointer: {show: false},
              axisLine: {show: false},
              position: 'bottom',
              offset: 20,
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisTick: {show: false},
              axisLine: {
                lineStyle: {
                  color: 'rgba(255,255,255,.1)'
                }
              },
              axisLabel:  {
                textStyle: {
                  color: "rgba(255,255,255,.6)",
                  fontSize:14,
                },
              },
              splitLine: {
                lineStyle: {
                  color: 'rgba(255,255,255,.1)'
                }
              }
            }
          ],
          series: [
            {
              name: '今年',
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  color: 'rgba(74, 221, 255, 1)',
                  width: 2
                }
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(74, 221, 255, 0.40)'
                  }, {
                    offset: 0.8,
                    color: 'rgba(74, 221, 255, 0)'
                  }], false),
                  shadowColor: 'rgba(74, 221, 255, 0.40)',
                }
              },
              itemStyle: {
                normal: {
                  color: 'rgba(74, 221, 255, 0.40)',
                  borderColor: 'rgba(74, 221, 255, 0.40)',
                  borderWidth: 12
                }
              },
              data: res.curYear || []
            },
            {
              name: '去年',
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  color: 'rgba(6, 247, 161,1)',
                  width: 2
                }
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(6, 247, 161, 1)'
                  }, {
                    offset: 1,
                    color: 'rgba(6, 247, 161, 0)'
                  }], false),
                  shadowColor: 'rgba(6, 247, 161, 1)',
                }
              },
              itemStyle: {
                normal: {
                  color: 'rgba(6, 247, 161, 1)',
                  borderColor: 'rgba(6, 247, 161, 1)',
                  borderWidth: 12
                }
              },
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }, 
          ]
        };
        myChart.setOption(option);
      },
      getRecordStatisticsTrendFn() {
        getRecordStatisticsTrend().then((res) => {
          if(!res.data || !res?.data?.length){
            return;
          };
          const barr = [0,0,0,0,0,0,0,0,0,0,0,0];
          const result = res.data || [];
          result.forEach((item) => {
            barr[item.month - 1] = item.recordNum || 0;
          });
          this.show = true;
          this.$nextTick(() => {
            this.init({
              curYear: barr
            });
          });
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .title {
    width: 100%;
    height: 14px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255,255,255,0.6);
    .tag1 {
      width: 10px;
      height: 10px;
      background: linear-gradient(180deg, rgba(74,221,255,1) 41%, rgba(74,221,255,0) 100%);
      margin-right: 8px;
    }
    .tag2 {
      width: 10px;
      height: 10px;
      background: linear-gradient(180deg, rgba(6,247,161,1) 0%, rgba(6,247,161,0) 100%);
      margin-right: 8px;
    }
    .mgn-r-16 {
      margin-right: 16px;
    }
    .unit {
      margin-left: auto;
    }
  }
  .con {
    position: relative;
    z-index: 0;
    width: 100%;
    height: 220px;
  }
</style>